import { GlLink, GlTooltipDirective } from '../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import RunnerTypeIcon from '../../../../runner/components/runner_type_icon.vue?vue3';
import { RUNNER_EMPTY_TEXT, RUNNER_NO_DESCRIPTION } from '../../constants';
export default {
    name: 'RunnerCell',
    i18n: {
        emptyRunnerText: RUNNER_EMPTY_TEXT,
        noRunnerDescription: RUNNER_NO_DESCRIPTION
    },
    components: {
        GlLink,
        RunnerTypeIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    computed: {
        adminUrl () {
            return this.job.runner?.adminUrl;
        },
        description () {
            return this.job.runner?.description ? this.job.runner.description : this.$options.i18n.noRunnerDescription;
        },
        runnerType () {
            return this.job.runner?.runnerType;
        }
    }
};
